import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { MsalProvider } from '@azure/msal-react';
import { pca } from './msalConfig';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <MsalProvider instance={pca}>
      <App />
    </MsalProvider>
  </StrictMode>
);
